import { posthog } from '@/app-shell/flags/posthog-compat';

// Community template likes and comments
export const IS_COMMUNITY_LIKES_ENABLED = () => {
  return posthog.isFeatureEnabled('release-community-likes') ?? false;
};

export const IS_TEMPLATE_FOOTER_ENABLED = () => {
  return posthog.isFeatureEnabled('release-template-footer');
};

/** Shipped 100% — PostHog `release-pinned-template-auto-generation`. */
export const IS_TEMPLATE_PINNING_ENABLED = () => true;

export const IS_FORMS_COMMUNITY_PAGE_ENABLED = () => {
  return posthog.isFeatureEnabled('release-forms-community-page');
};

export const IS_RELEASE_FORM_FILLING_FLOW_ALIGNMENT_ENABLED = () => {
  // FLAG_CLEANUP: hardcoded false because the PostHog flag is no longer configured.
  return false;
};

export const IS_TEMPLATE_CREATION_RECORD_ENABLED = () => {
  return posthog.isFeatureEnabled('release-template-creation-record');
};

export const IS_USER_FORM_TEMPLATE_REQUESTS_ENABLED = () => {
  return posthog.isFeatureEnabled('release-user-form-template-requests');
};

export const IS_NHS_COMP_V2_ENABLED = () => {
  return posthog.isFeatureEnabled('release-nhs-comp-v2');
};

// ml-scribe gates the template compliance check on these keys. Read them in the browser for
// analytics only (`compliance_check_enabled`), never to gate: posthog-js and the backend can
// disagree. Do not delete the PostHog flags.
export const IS_COMPLIANCE_CHECK_CREATE_TEMPLATE_ENABLED = () => {
  return posthog.isFeatureEnabled('release-compliance-check-create-template', {
    send_event: false,
  });
};

export const IS_COMPLIANCE_CHECK_UPDATE_TEMPLATE_ENABLED = () => {
  return posthog.isFeatureEnabled('release-compliance-check-update-template', {
    send_event: false,
  });
};

export const IS_TEMPLATE_BUILDER_SESSION_TRANSCRIPT_PICKER_ENABLED = () => {
  return posthog.isFeatureEnabled('release-template-builder-session-transcript-picker');
};

/** Shipped 100% — PostHog `release-pinned-template-auto-generation`. */
export const useIsTemplatePinningEnabled = () => true;
